export const UUID_PATTERN = /^[\da-f]{8}(?:\b-[\da-f]{4}){3}\b-[\da-f]{12}$/i;
export const SLUG_TRAILING_SLASH_PATTERN = /^(.+)\/$/;
